import * as TYPES from './facility-actiontypes';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import * as auth from '../auth/auth-middleware';
import * as api from './facility-api';
import * as actions from './facility-action-creators';
import { loadTranslations,
  languageChange,
} from '../language/language-middleware';


export const facilityLoaded = (response) => {
  const state = {
    theme: api.getThemeSource(response.themeId),
    facilityName: response.facilityName,
    facilityPortalName: response.facilityPortalName,
    facilityShortName: response.facilityShortName,
    facilityId: response.facilityId,
    timeZoneAbbreviation: response.timeZoneAbbreviation,
    timeZoneId: response.timeZoneId,
    dateFormat: 'MM/DD/YYYY h:mm A',
    timeZoneOffset: response.timeZoneOffset,
    defaultCommunicationLanguageId: response.defaultCommunicationLanguageId,
  };

  return {
    type: TYPES.FACILITY_LOADED_SUCCESS,
    state,
  };
};

const facilityLoadFailure = (message) => ({
  type: TYPES.FACILITY_LOADED_FAILURE,
  state: {
    error: message,
  },
});

export const facilityLogoRequested = (facilityId) => (dispatch) => {
  const logoUrl = api.getLogoUrl(facilityId);
  dispatch(actions.facilityLogoLoaded(logoUrl));
};

export const loadFacility = (appUrl) => (dispatch, storeState) => {
  const sState = storeState() || { language: {} };
  let languageCode = sState && sState.language ? sState.language.languageCode : null;

  return api.getFacilityInfo(appUrl).then(
    (response) => {
      if (languageCode === null && response.data.defaultCommunicationLanguageName) {
        languageCode = response.data.defaultCommunicationLanguageName;
        dispatch(languageChange(languageCode));
      }
      dispatch(facilityLoaded(response.data));
      dispatch(facilityLogoRequested(response.data.facilityId));
      dispatch(loadTranslations(languageCode, response.data.facilityId));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(facilityLoadFailure(error.message));
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
  );
};

export const loadFacilityByPatientId = (patientId, loginCallBack, userInfo) => (dispatch, storeState) => {
  const sState = storeState() || { language: {} };
  const languageCode = sState && sState.language ? sState.language.languageCode : null;

  return api.getPatientFacilityInfo(patientId).then(
    (response) => {
      dispatch(facilityLoaded(response.data));
      dispatch(facilityLogoRequested(response.data.facilityId));
      dispatch(loadTranslations(languageCode, response.data.facilityId)).then(
        () => {
          if (loginCallBack) {
            loginCallBack(userInfo);
          }
        }
      );
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(facilityLoadFailure(error.message));
    }
  );
};

export const loadFaqs = (facilityId) => (dispatch) =>
  api.getFaqs(facilityId)
    .then(
      (response) => dispatch(actions.facilityFaqsLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(actions.facilityFaqsLoadFailure(error.message));
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadUsefulLinks = (facilityId) => (dispatch) =>
  api.getUsefulLinks(facilityId)
    .then(
      (response) => dispatch(actions.usefulLinksLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(actions.usefulLinksLoadFailure(error.message));
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

const openDownloadableFormInWindow = (download, accessToken, newTabWindow) => (
  Object.assign(newTabWindow, {
    location: api.getDownloadLink(download.facilityId,
      download.downloadableItemId,
      accessToken),
  })
);

export const downloadForm = (download, newWin) => (dispatch) =>
  dispatch(auth.getNewAccessTokenFromForcedRefresh())
    .then(
      (accessToken) => openDownloadableFormInWindow(
        download,
        accessToken,
        newWin),
      () => null
    );

export const loadDownloadableForms = (facilityId) => (dispatch) =>
  api.getDownloadableForms(facilityId)
    .then(
      (response) => dispatch(actions.downloadableFormsLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(actions.downloadableFormsLoadFailure(error.message));
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );
